exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#menu.open[data-v-2f248fd2]{transform:translateX(0)!important}.no-scrollbar[data-v-2f248fd2]::-webkit-scrollbar{display:none}.no-scrollbar[data-v-2f248fd2]{-ms-overflow-style:none;scrollbar-width:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f248fd2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Menu.vue
// module id = 705
// module chunks = 0